document.addEventListener('DOMContentLoaded', function () {
  const selectedBrand = window.resolveSelectedBrand();

  updateMenu(normalize(selectedBrand));
  updateLogo(normalize(selectedBrand));
  updateBrandMenu(normalize(selectedBrand));
  updateSubBrand(normalize(selectedBrand));

  /**
   * GMS - Breadcrumbs Update - 22/10/2026
   * Synchronize breadcrumbs with the selected storefront brand.
   */
  updateBreadcrumb(normalize(selectedBrand));
});

function normalize(name) {
  return name.toLowerCase().replace(/\s+/g, '-');
}

function updateMenu(brand) {
  const menuTemplate = document.getElementById(`menu-template-${brand}`);
  const menuWrapper = document.querySelector('.mega-menu-navigation-wrapper');

  // Menu template HTML
  if (menuTemplate && menuWrapper) {
    menuWrapper.innerHTML = menuTemplate.innerHTML;
  } else {
    // Fallback : Display menu home-society if brand doesnt exist
    const defaultTemplate = document.getElementById('menu-template-home-society');
    if (defaultTemplate && menuWrapper) {
      menuWrapper.innerHTML = defaultTemplate.innerHTML;
    }
  }

  window.dispatchEvent(new Event('resize'));
}

// Utility function for resolving the selected brand for menu selection
function resolveSelectedBrand() {
  const fallbackBrand = 'home-society';
  const allowedBrands = ['maison-corbeil', 'jardin-de-ville', 'must', 'la-galerie-du-meuble'];

  const urlParams = new URLSearchParams(window.location.search);
  const urlBrand = urlParams.get('brand');
  const normalizedUrlBrand = urlBrand ? normalize(urlBrand) : null;

  const storedBrand = sessionStorage.getItem('brandScope') || fallbackBrand;
  const normalizedStoredBrand = normalize(storedBrand);

  const isValidUrlBrand = normalizedUrlBrand && allowedBrands.includes(normalizedUrlBrand);
  const effectiveBrand = isValidUrlBrand ? normalizedUrlBrand : normalizedStoredBrand;

  // Only save to sessionStorage if the brand is valid and from URL
  if (isValidUrlBrand) {
    sessionStorage.setItem('brandScope', normalizedUrlBrand);
  }

  const brandElement = document.querySelector('.page-width[data-brand]');
  const productBrandRaw = brandElement?.dataset.brand;

  if (productBrandRaw) {
    const productBrandList = productBrandRaw
      .replace(/[\[\]]/g, '')
      .split(',')
      .map((b) => b.trim());

    const normalizedProductBrands = productBrandList.map(normalize);
    const matchIndex = normalizedProductBrands.indexOf(effectiveBrand);

    if (isValidUrlBrand) return urlBrand;
    return matchIndex !== -1 ? productBrandList[matchIndex] : fallbackBrand;
  }

  return isValidUrlBrand ? urlBrand : storedBrand;
}

window.resolveSelectedBrand = resolveSelectedBrand;

function updateLogo(brand) {
  const logoTemplate = document.getElementById(`menu-logo-template-${brand}`);
  const logoWrapper = document.querySelector('.logo-mobile-wrapper');

  // Menu template HTML
  if (logoTemplate && logoWrapper) {
    logoWrapper.innerHTML = logoTemplate.innerHTML;
  } else {
    // Fallback : affiche le menu home-society si la brand n'existe pas
    const defaultTemplate = document.getElementById('menu-logo-template-home-society');
    if (defaultTemplate && logoWrapper) {
      logoWrapper.innerHTML = defaultTemplate.innerHTML;
    }
  }
}

function updateBrandMenu(brand) {
  if (brand === 'home-society') {
    const defaultLinks = document.querySelectorAll('.top-nav-main, .top-nav-brand-list, footer .brand-list');
    defaultLinks.forEach((item) => {
      let link = item.querySelector('a');
      if (link) {
        link.setAttribute('aria-current', 'page');
      }
    });

    return;
  }

  const normalizedBrand = brand.toLowerCase().replace(/\s+/g, '-');
  const navItems = document.querySelectorAll('.nav-item, .brand-list li');

  navItems.forEach((item) => {
    const brandElement = item.querySelector('.brand, .brand-mobile');

    if (brandElement) {
      const normalizedContent = brandElement.innerHTML.toLowerCase().replace(/\s+/g, '-');

      if (normalizedContent == normalizedBrand) {
        const link = item.querySelector('a');
        if (link) {
          link.setAttribute('aria-current', 'page');
        }
      }
    }
  });
}


/**
 * GMS - Breadcrumbs Update - 22/10/2026
 *
 * Display the breadcrumb corresponding to the selected storefront brand.
 * Hide breadcrumbs belonging to other brands.
 */
function updateBreadcrumb(brand) {
  const breadcrumbs = document.querySelectorAll('.breadcrumb-brand-path');

  if (!breadcrumbs.length) return;

  const activeBrand = brand === 'must-societe' ? 'must' : brand;

  breadcrumbs.forEach((breadcrumb) => {
    const isActive = breadcrumb.dataset.brand === activeBrand;

    breadcrumb.hidden = !isActive;
    breadcrumb.style.display = isActive ? '' : 'none';
  });
}




/**
 * GMS - PDP Sub Brand by Selected Brand - 26/10/2026
 *
 * Displays the correct sub brand collection based on the
 * currently selected navigation brand.
 *
 * Fallback to default sub_brand when the brand-specific
 * metafield is not available.
 */
function updateSubBrand(brand) {
  const wrappers = document.querySelectorAll('[data-sub-brand-wrapper]');

  if (!wrappers.length) return;

  const activeBrand = brand === 'must-societe' ? 'must' : brand;

  wrappers.forEach((wrapper) => {
    const links = wrapper.querySelectorAll('[data-sub-brand]');

    // Hide all sub brand links
    links.forEach((link) => {
      link.hidden = true;
      link.style.display = 'none';
    });

    // Find the sub brand matching the active navigation brand
    let selectedLink = wrapper.querySelector(
      `[data-sub-brand="${activeBrand}"]`
    );

    // Fallback to the default sub_brand
    if (!selectedLink) {
      selectedLink = wrapper.querySelector(
        '[data-sub-brand="default"]'
      );
    }

    // Display the selected sub brand
    if (selectedLink) {
      selectedLink.hidden = false;
      selectedLink.style.display = '';
      wrapper.hidden = false;
    } else {
      wrapper.hidden = true;
    }
  });
}
